module.exports = __webpack_public_path__ + "be5087b274a44791ee89622381c02532.MP3";